import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus } from 'lucide-react';
interface AccordionItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onClick: () => void;
}
function AccordionItem({
  question,
  answer,
  isOpen,
  onClick
}: AccordionItemProps) {
  return <div className="bg-bg-card border-b border-border-subtle overflow-hidden" data-id="element-255">
      <button className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none group hover:bg-bg-card-hover transition-colors" onClick={onClick} data-id="element-256">
        <span className="text-[16px] font-[600] text-white group-hover:text-accent transition-colors" data-id="element-257">
          {question}
        </span>
        <motion.div animate={{
        rotate: isOpen ? 45 : 0
      }} transition={{
        duration: 0.2
      }} className="flex-shrink-0 ml-4 text-accent" data-id="element-258">
          <Plus className="w-5 h-5" data-id="element-259" />
        </motion.div>
      </button>
      <AnimatePresence initial={false} data-id="element-260">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="overflow-hidden bg-bg-card" data-id="element-261">
            <div className="px-6 pb-5 text-[15px] text-text-secondary leading-[1.7]" data-id="element-262">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
interface AccordionProps {
  items: {
    question: string;
    answer: string;
  }[];
}
export function Accordion({
  items
}: AccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <div className="w-full max-w-3xl mx-auto border-t border-border-subtle" data-id="element-263">
      {items.map((item, index) => <AccordionItem key={index} question={item.question} answer={item.answer} isOpen={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-264" />)}
    </div>;
}